import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories, MAIN_SITE_URL } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const footerCategories = categories.slice(0, 6);

  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-base">{t('common.brand')}</span>
            </Link>
            <p className="mt-4 text-sm text-background-100/80 leading-relaxed max-w-sm">
              {t('common.footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-100/90 mb-4">
              {t('common.footer.resourcesTitle')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-background-100/70 hover:text-background-50 transition-colors">
                  {t('common.nav.spreadsheet')}
                </Link>
              </li>
              <li>
                <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-background-100/70 hover:text-background-50 transition-colors">
                  {t('common.cta.visitMain')}
                </a>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-100/70 hover:text-background-50 transition-colors">
                  {t('common.nav.faq')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-100/90 mb-4">
              {t('common.footer.categoriesTitle')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.key}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-100/70 hover:text-background-50 transition-colors">
                    {t(`categories.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} {t('common.brand')}. {t('common.footer.rights')}
          </p>
          <p className="text-xs text-background-100/50 max-w-md">
            {t('common.footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}